import { AssessmentType } from 'lib/documents/patient-assessment/patient-assessment';

export interface PatientPhaseEligibility {
  phase_1_skipped: boolean;
  phase_2_skipped: boolean;
  activeStatus: string | null;
}

export function determinePatientEligibility(
  assessments: { status: string; assessmentType?: string }[],
  requestedType: AssessmentType | null
): PatientPhaseEligibility {
  const activeAssessment = assessments.find(
    a => a.status === 'pending' || a.status === 'started'
  );

  let phase_1_skipped = false;
  let phase_2_skipped = false;
  let activeStatus: string | null = null;

  if (activeAssessment) {
    activeStatus = activeAssessment.status;
    phase_1_skipped = true;
    if (requestedType && activeAssessment.assessmentType !== requestedType) {
      phase_2_skipped = true;
    }
  }

  return {
    phase_1_skipped,
    phase_2_skipped,
    activeStatus
  };
}
